"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigService = void 0;
var tslib_1 = require("tslib");
var constants_1 = require("../../constants/constants");
var sdk_1 = require("../../sdk/sdk");
var networkServiceDefault_1 = require("../network/networkServiceDefault");
/**
 * Implementation of the ConfigProvider interface for a generic configuration service.
 * @class
 * @implements {ConfigProvider}
 */
var ConfigService = /** @class */ (function () {
    function ConfigService(networkService) {
        if (networkService === void 0) { networkService = new networkServiceDefault_1.NetworkServiceDefault(); }
        this.networkService = networkService;
    }
    ConfigService.prototype.fetchConfiguration = function (apiEndpointBaseUrl) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var platform, url, requestable, response, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        platform = sdk_1.VelvetSDK.appConfig.platform;
                        url = "".concat(apiEndpointBaseUrl, "/parsed/").concat(constants_1.CMS_ROUTE_DATA.CONFIG, "/").concat(platform);
                        requestable = {
                            url: url,
                            method: constants_1.HTTP_METHOD.GET,
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.networkService.fetch(requestable)];
                    case 2:
                        response = _a.sent();
                        sdk_1.VelvetSDK.Configuration.configuration = response;
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error('Error fetching the configuration:', error_1);
                        throw new Error('Failed to fetch the configuration data');
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return ConfigService;
}());
exports.ConfigService = ConfigService;
